import React from 'react';
import { LayoutDashboard, Settings, LogOut, ChevronLeft, ChevronRight, Activity, Layout, FileText, MonitorPlay } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../store/authSlice';
import DynamicLogo from '../assets/Dynamic_Logo.png';
import SmallLogo from '../assets/Daynamic_small_logo.ico';
import './Sidebar.css';

const Sidebar = ({ activeView = 'dashboard', setActiveView, isCollapsed, setIsCollapsed, isMobileOpen, setIsMobileOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <>
      {isMobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99, backdropFilter: 'blur(4px)' }}
        />
      )}
      <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo" style={{
          padding: isCollapsed ? '20px 12px 16px' : '20px 16px 16px',
          position: 'relative',
          borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
          marginBottom: '16px'
        }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6
          }}>
            <div style={{
              width: isCollapsed ? 48 : '100%',
              maxWidth: isCollapsed ? 48 : 220,
              height: isCollapsed ? 48 : 70,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 14,
              padding: isCollapsed ? '4px' : '8px 16px',
              background: '#FFFFFF',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.28)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            }}>
              <img
                src={isCollapsed ? SmallLogo : DynamicLogo}
                alt="Dynamic Agent Logo"
                style={{
                  maxHeight: isCollapsed ? 38 : 60,
                  maxWidth: isCollapsed ? 38 : 200,
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))'
                }}
              />
            </div>
            {!isCollapsed && (
              <span className="logo-text" style={{ fontSize: 11, fontWeight: 800, color: '#FFFFFF', letterSpacing: '.08em', whiteSpace: 'nowrap', textTransform: 'uppercase', marginTop: 2 }}>
                DYNAMIC AGENT
              </span>
            )}
          </div>
          <button className="collapse-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
            {isCollapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            <li className={`nav-item ${activeView === 'dashboard' ? 'active' : ''}`}>
              <a href="/dashboard" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('dashboard'); navigate('/dashboard'); }} title="Dashboard">
                <LayoutDashboard size={18} />
                {!isCollapsed && <span>Dashboard</span>}
              </a>
            </li>
            <li className={`nav-item ${activeView === 'live-monitor' ? 'active' : ''}`}>
              <a href="/LiveMonitor" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('live-monitor'); navigate('/LiveMonitor'); }} title="Live Monitor">
                <Activity size={18} />
                {!isCollapsed && <span>Live Monitor</span>}
              </a>
            </li>
            <li className={`nav-item ${activeView === 'pc-info' ? 'active' : ''}`}>
              <a href="/pc-info" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('pc-info'); navigate('/pc-info'); }} title="PC Info">
                <MonitorPlay size={18} />
                {!isCollapsed && <span>PC Info</span>}
              </a>
            </li>
            <li className={`nav-item ${activeView === 'all-masters' ? 'active' : ''}`}>
              <a href="/masters" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('all-masters'); navigate('/masters'); }} title="ALL Master">
                <Layout size={18} />
                {!isCollapsed && <span>ALL Master</span>}
              </a>
            </li>
            <li className={`nav-item ${activeView === 'app-usage' ? 'active' : ''}`}>
              <a href="/reports/app-usage" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('app-usage'); navigate('/reports/app-usage'); }} title="App Usage Report">
                <FileText size={18} />
                {!isCollapsed && <span>App Usage Report</span>}
              </a>
            </li>
            <li className={`nav-item ${activeView === 'idle-time' ? 'active' : ''}`}>
              <a href="/reports/idle-time" onClick={(e) => { e.preventDefault(); setActiveView && setActiveView('idle-time'); navigate('/reports/idle-time'); }} title="Idle Time Report">
                <FileText size={18} />
                {!isCollapsed && <span>Idle Time Report</span>}
              </a>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <nav className="sidebar-nav">
            <ul>
              <li className="nav-item">
                <a href="#" onClick={(e) => e.preventDefault()} title="Settings">
                  <Settings size={18} />
                  {!isCollapsed && <span>Settings</span>}
                </a>
              </li>
              <li className="nav-item">
                <button onClick={handleLogout} className="logout-btn" title="Logout">
                  <LogOut size={18} />
                  {!isCollapsed && <span>Logout</span>}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
